<template>
  <div class="main-container">
    <div class="banner">
      <div class="wrap">
        <div class="top">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>资源</el-breadcrumb-item>
            <el-breadcrumb-item>亚马逊-实习指导书</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="bottom">
          <p class="title">亚马逊-实习指导书</p>
          <div class="info">
            <span class="intro">0基础入门, 轻松上手掌握亚马逊电子商务平台</span>
            <span class="sep">|</span>
            <a><span>入门 / 实习指导书</span></a>
            <span class="i">•</span>
            <span>共32节</span>
            <span class="i">•</span>
            <span>225人已学习</span>
          </div>
          <div class="price">
            <div class="price-text">
              <p class="sale">¥ 免费</p>
            </div>
            <a class="sale-price l"> 订阅学习 </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="left_con">
        <div
          class="img"
          style="
            background-image: url(https://xqimg.imedao.com/17c12bc9ff71b963fe9b2b2b.png%21800.jpg);
          "
        >
          <div class="ebook">实习指导书</div>
        </div>
        <div class="left-item">
          <div style="width: 20px">
            <i class="el-icon-caret-right"></i>
          </div>
          <a class="active">课程详细</a>
        </div>
        <div class="left-item">
          <div style="width: 20px"></div>
          <a class="">课程目录</a>
        </div>
      </div>

      <div class="center_con">
        <div class="chapter">
          <div class="catalog-title">
            课程目录
            <span>已更新32节</span>
          </div>
          <div class="item-box">
            <div class="item">
              <div class="section">
                <p class="sec_name">第1章：商城首页</p>
              </div>
              <ul>
                <li>
                  <a>
                    <div class="articleName">
                      01 开篇词：商城首页还不明白吗？
                    </div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="taste-btn">阅读</div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
                <li>
                  <a>
                    <div class="articleName">02 商城首页商城设置</div>
                    <div class="info">
                      <span>2023-05</span>
                    </div>
                    <div class="lock-btn">
                      <i class="el-icon-lock"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="content" style="display: none">
          <h3 style="padding-top: 20px">
            学学习学习学习学习学学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容学学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习学习习内容
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.banner {
  width: 100%;
  height: 244px;
  background-color: #383d42;
}
.wrap {
  width: 1152px;
  margin: 0 auto;
  padding-left: 176px;
  padding-top: 24px;
  box-sizing: border-box;
}

.top {
  width: 100%;
  margin-bottom: 8px;
  height: 24px;
}

.top ::v-deep span {
  line-height: 24px;
  font-size: 12px;
  font-weight: 400 !important;
  color: rgba(255, 255, 255, 0.6) !important;
}

.title {
  font-size: 24px;
  color: #fff;
  line-height: 24px;
  text-align: left;
  margin-bottom: 16px;
}

.bottom .info {
  font-size: 0;
  margin-bottom: 16px;
}

.info .intro {
  font-size: 16px;
  color: #fff;
  text-align: left;
  line-height: 16px;
  display: inline-block;
  max-width: 402px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.info span {
  display: inline-block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
  line-height: 16px;
}

.sep {
  color: rgba(255, 255, 255, 0.2);
  margin: 0 24px;
}

.i {
  padding: 0 4px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
  line-height: 16px;
}

.price {
}

.price-text {
  margin-bottom: 8px;
}

.sale {
  font-size: 24px;
  color: #fff;
  text-align: left;
  line-height: 32px;
  margin-right: 16px;
}

.sale-price {
  padding: 8px 24px;
  background: #37f;
  border-radius: 24px;
  color: #fff;
  font-size: 16px;
}
.l {
  float: left;
}

.container {
  width: 1152px;
  margin: 0 auto;
  margin-bottom: 36px;

  display: flex;
}

.left_con {
  width: 144px;
  position: relative;
  top: -220px;
  left: 0;
  margin-right: 32px;
}

.left_con .img {
  width: 144px;
  height: 191.3px;
  margin: 0 auto;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 4px 7px 0 rgba(28, 31, 33, 0.06),
    0 7px 14px 0 rgba(28, 31, 33, 0.06), 0 11px 21px 0 rgba(28, 31, 33, 0.06),
    0 14px 28px 0 rgba(28, 31, 33, 0.06);
  border-radius: 10.67px;
  margin-bottom: 28.7px;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}
.left-item {
  width: 100%;
  height: 54px;
  line-height: 54px;
  font-size: 0;

  display: flex;
}

.left-item i {
  font-size: 20px;
  color: #37f;
  text-align: left;
  line-height: 54px;
}

.left-item a {
  display: inline-block;
  width: 120px;
  font-size: 16px;
  color: #1c1f21;
  text-align: left;
  line-height: 54px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
  vertical-align: top;
}

.left-item a.active {
  color: #37f;
  font-weight: 700;
  border-bottom: 1px solid #37f;
}

.left_con .img .ebook {
  position: absolute;
  bottom: 5px;
  left: 6px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgba(28, 31, 33, 0.2);
  border-radius: 13px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 12px;
  padding: 6px 8px;
}

.center_con {
  /* width: 680px; */
  width: 976px;
  margin-top: -24px;
  position: relative;
}

/* 内容 */
.center_con .content {
  background: #fff;
  padding: 0 32px 32px;
  box-sizing: border-box;
}

/* 章节 */
.center_con .chapter {
  background: #fff;
  padding: 16px 32px;
  box-sizing: border-box;
  position: relative;
}

.catalog-title {
  font-size: 18px;
  color: #1c1f21;
  line-height: 18px;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
  padding: 16px 0;
  font-weight: 700;
  margin-bottom: 16px;
}

.catalog-title span {
  font-size: 12px;
  color: #9199a1;
  text-align: left;
  line-height: 18px;
  margin-left: 16px;
  font-weight: 400;
}

.item-box {
}

.item {
}

.item .section {
  width: 100%;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.sec_name {
  width: 100%;
  font-size: 15px;
  color: #1c1f21;
  line-height: 18px;
  text-align: left;
  font-weight: 700;
  padding: 16px 0;
}

ol,
ul {
  list-style: none;
}

.item ul li {
  position: relative;
  box-sizing: border-box;
  padding: 16px 0;
  border-bottom: 1px solid rgba(28, 31, 33, 0.1);
}

.item ul li .articleName {
  max-width: 380px;
  font-size: 15px;
  color: #1c1f21;
  line-height: 24px;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.item ul li .info span {
  font-size: 14px;
  color: #9199a1;
  line-height: 14px;
}

.item ul li .taste-btn {
  width: 76px;
  height: 36px;
  position: absolute;
  top: 16px;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #37f;
  line-height: 36px;
  font-weight: 700;
  background: rgba(51, 119, 255, 0.1);
  border-radius: 18px;
  transition: all 0.3s;
  -moz-transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
}

.item ul li .lock-btn {
  position: absolute;
  top: 16px;
  right: 30px;
  font-size: 16px;
  color: #9199a1;
  line-height: 24px;
  cursor: pointer;
}
</style>